import { Inject, Injectable } from '@angular/core';
import { OldDataService } from 'src/app/core/services/old-data.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Order } from '../../core/models/client';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';

@Injectable({
	providedIn: 'root',
})
export class OrdersService {
	constructor(
		private dataService: OldDataService,
		private http: HttpClient,
		private utils: UtilsService
	) {}

	getTypeOrders() {
		const url = `${environment.api}orders/get_type_order`;
		return this.http.get(url);
	}
	add_order(payload: Order) {
		const url = `${environment.api}orders/add_order_client`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	listCampaignOrders(user_id: number) {
		const url = `${environment.api}orders/${user_id}/get_order_campaign`;
		return this.http.get(url);
	}

	deactivateOrder(order_id: any) {
		const url = `${environment.api}orders/${order_id}/deactivate_order`;
		return this.http.get(url);
	}
	getOrderStatus() {
		const url = `${environment.api}orders/get_order_status`;
		return this.http.get(url);
	}

	change_status_order(
		idOrder: number,
		status: number,
		start_date: string,
		idCustomer: number,
		idUser: number,
		type: number,
	) {
		const url = `${environment.api}orders/update_status_order`;
		const payload = {
			idOrder: idOrder,
			idStatus: status,
			date_start: start_date,
			idCustomer: idCustomer,
			idUser: idUser,
			type: type,
		}
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	getDataOrderByCampaign(campaign_id) {
		const url = `${environment.api}orders/${campaign_id}/get_order_by_campaign`;
		return this.http.get(url);
	}
	getRemainingLeads(order_id) {
		const url = `${environment.api}orders/${order_id}/get_remaining_leads`;
		return this.http.get(url);
	}
	getHoursCampaign(id: any, startdate: string) {
		const url = `${environment.api}orders/get_hours_campaign`;
		const payload = { campaign_id: id, start_date: startdate }
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}
	getDataOrderByCampaign_all(campaign_id: any) {
		const url = `${environment.api}orders/${campaign_id}/get_order_by_campaign_all`;
		return this.http.get(url);
	}
}
